"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _temp;

var PromiseRenderer = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(PromiseRenderer, _Component);

  function PromiseRenderer() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, PromiseRenderer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(PromiseRenderer)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "promise", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "pending", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "error", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "success", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "extra", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      resolved: false,
      resolvedSuccess: false,
      resolvedValue: null,
      resolvedError: null
    };
    return _this;
  }

  babelHelpers.createClass(PromiseRenderer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.promise) this.promise.then(function (value) {
        return _this2.setState({
          resolved: true,
          resolvedSuccess: true,
          resolvedValue: value
        });
      }, function (err) {
        return _this2.setState({
          resolved: true,
          resolvedSuccess: false,
          resolvedError: err
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      if (prevProps.promise != this.promise) {
        this.setState({
          resolved: false,
          resolvedSuccess: false,
          resolvedValue: null,
          resolvedError: null
        }, function () {
          if (_this3.promise) _this3.promise.then(function (value) {
            return _this3.setState({
              resolved: true,
              resolvedSuccess: true,
              resolvedValue: value
            });
          }, function (err) {
            return _this3.setState({
              resolved: true,
              resolvedSuccess: false,
              resolvedError: err
            });
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.resolved) return this.pending(this.extra);
      if (this.state.resolvedSuccess) return this.success(this.state.resolvedValue, this.extra);
      return this.error(this.state.resolvedValue, this.extra);
    }
  }]);
  return PromiseRenderer;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "promise", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "pending", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      return null;
    };
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "error", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function (error) {
      return null;
    };
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "success", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function (value) {
      return null;
    };
  }
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "extra", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
})), _class);
exports.default = PromiseRenderer;